import _ from "lodash"
import moment from "moment"

import CONFIG from "../../environment"

// TODO DX-1543 in the new implementation of the customer details page
// we deal with individual field errors, not a collection of errors like in the current version.
// The makeError function previously accepted only objects containing "error" and "touched" properties
// for every field, but now we need it to be able to handle "error" and "touched" per individual field,
// in which case both are strings. We should check at the end of the implementation if we
// still need this function to accept both object and string, or if just string is enough
export const makeError = (error, touched, fieldName, params = {}) => {
  const key = typeof error === "string" ? error : _.get(error, fieldName)
  const hasError =
    Boolean(key) && (typeof touched === "boolean" ? touched : Boolean(_.get(touched, fieldName)))

  return {
    key,
    hasError,
    params
  }
}

export const makeFutureDate = (reference, offset, unit = "days") => {
  const today = moment()
  const dateReference = reference || today
  return dateReference.clone().add(offset, unit)
}

export const makePastDate = (reference, offset, unit = "days") => {
  const today = moment()
  const dateReference = reference || today
  return dateReference.clone().subtract(offset, unit)
}

export const getDateInRange = date => {
  const today = moment()

  const minAvailableDate = today
  const maxAvailableDate = today.clone().add(CONFIG.REACT_APP_CALENDAR_MAX_AVAILABLE_DAYS, "days")

  if (date.isBefore(minAvailableDate)) {
    return minAvailableDate
  }
  if (date.isAfter(maxAvailableDate)) {
    return maxAvailableDate
  }

  return date
}

export const makeFutureDateInRange = (reference, offset, unit) => {
  return getDateInRange(makeFutureDate(reference, offset, unit))
}
